import type React from 'react';
import { observer } from 'mobx-react';
import { Box, Text } from 'braid-design-system';
import * as styles from './CertsyCredentialDetailWrapper.css';
import RoleRequirementIcon from 'src/components/list/JobApplicationCard/RoleRequirementsView/RoleRequirement/RoleRequirementIcon';
import HotjarMask from 'src/components/common/HotjarMask';
import CertsyBrand from 'src/components/common/Certsy/Icons/CertsyBrand';
import { STATUS_CERTIFIED } from 'src/constants/roleRequirementStatus';

interface Props {
  certsyTitle: string;
  children: React.ReactElement;
}

export const CertsyCredentialDetailWrapper = observer(
  ({ certsyTitle, children }: Props) => (
    <Box
      marginBottom="medium"
      display="flex"
      flexDirection="row"
      justifyContent="spaceBetween"
      flexWrap="wrap"
    >
      <Box marginBottom="medium">
        <Box
          display="flex"
          flexDirection="row"
          marginBottom="medium"
          alignItems="center"
        >
          <Box marginLeft="xxsmall">
            <Text>
              <RoleRequirementIcon status={STATUS_CERTIFIED} />
            </Text>
          </Box>
          <Box marginLeft="small">
            <Text weight="strong">
              <HotjarMask>{certsyTitle}</HotjarMask>
            </Text>
          </Box>
        </Box>
        <Box marginLeft="large" className={styles.credentialDetails}>
          {children}
        </Box>
      </Box>

      <Box
        marginLeft="large"
        marginBottom="medium"
        className={styles.certsyBrand}
      >
        <CertsyBrand />
      </Box>
    </Box>
  ),
);
